import { useCallback, useMemo } from "react";
import { MOBILE_NAV_BREAKPOINT } from "./constants";

export default function useMobileBottomNav({
  navigate,
  location,
  toggleSidebar,
  isSidebarMinimized,
}) {
  const activeId = useMemo(() => {
    const path = location.pathname || "";
    const params = new URLSearchParams(location.search || "");
    if (path.startsWith("/ai-copilot") || path.startsWith("/user/ai-copilot")) return "copilot";
    if (path.startsWith("/dashboard") && params.get("mobileTab") === "products") return "products";
    if (path.startsWith("/settings/products")) return "products";
    if (path.startsWith("/dashboard")) return "dashboard";
    return null;
  }, [location.pathname, location.search]);

  const closeDrawerIfOpen = useCallback(() => {
    if (window.innerWidth < MOBILE_NAV_BREAKPOINT && isSidebarMinimized) {
      toggleSidebar();
    }
  }, [isSidebarMinimized, toggleSidebar]);

  const onMenu = useCallback(() => {
    toggleSidebar();
  }, [toggleSidebar]);

  const onDashboard = useCallback(() => {
    navigate("/dashboard");
    closeDrawerIfOpen();
  }, [navigate, closeDrawerIfOpen]);

  const onProducts = useCallback(() => {
    navigate("/dashboard?mobileTab=products");
    closeDrawerIfOpen();
  }, [navigate, closeDrawerIfOpen]);

  const onCopilot = useCallback(() => {
    navigate("/ai-copilot");
    closeDrawerIfOpen();
  }, [navigate, closeDrawerIfOpen]);

  return { activeId, onMenu, onDashboard, onProducts, onCopilot };
}
